/**
 * Este archivo se ha dispuesto para simular la obtención de contenido desde contentful
 * de forma que se pueda incluir facilmente en contentful cuando sea necesario, realizando
 * cambios minimos en el código
 * 
 * El contenido original se encuentra en este archivo:
 *    https://docs.google.com/document/d/1XEUngljF8i3UJhZWcIAKk9Sv0fyaTyFWlcyYbMiuk5s/edit
 */
export const contenidoRedencion = {
    "json": {
      "nodeType": "document",
      "data": {},
      "content": [
        {
          "nodeType": "paragraph",
          "content": [
            {
              "nodeType": "text",
              "value": "¿Estás segura de que quieres redimir %COST% puntos para hacer tu consulta?",
              "marks": [
                {
                  "type": "bold"
                }
              ],
              "data": {}
            }
          ],
          "data": {}
        },
        {
          "nodeType": "paragraph",
          "content": [
            {
              "nodeType": "text",
              "value": "%REDEEM%",
              "marks": [],
              "data": {}
            }
          ],
          "data": {}
        },
        {
          "nodeType": "paragraph",
          "content": [
            {
              "nodeType": "text",
              "value": "Si no tienes puntos, ¡TRANQUILA!",
              "marks": [
                {
                  "type": "bold"
                }
              ],
              "data": {}
            },
            {
              "nodeType": "text",
              "value": " Ingresa aquí las claves de tus productos Nosotras.",
              "marks": [
                {
                  "type": "bold"
                }
              ],
              "data": {}
            }
          ],
          "data": {}
        },
        {
          "nodeType": "paragraph",
          "content": [
            {
              "nodeType": "text",
              "value": "%SEND%",
              "marks": [],
              "data": {}
            }
          ],
          "data": {}
        }
      ]
    }
  }